import css from '@src/styles/scroll.scss';

export default class Scroll {

    constructor(element = null) {

        this.element = element ?? document.body;
    }

    enable() {

        this.element.classList.remove(css['no-scroll']);
    }

    disable() {

        this.element.classList.add(css['no-scroll']);
    }
    
}